import { yup } from '@medely/ui-kit';

export const specialtiesFormSchema = yup.object({
  specialty_ids: yup.array(),
});
